import * as Types from '../constants/Types';

export const getAllHomestays = () => ({ type: Types.HOMESTAY_All_ACTION });
export const setAllHomestays = (homestays) => ({ type: Types.HOMESTAY_All_SUCCESS, homestays });

export const getListHomestays = (filters) => ({ type: Types.HOMESTAY_LIST_ACTION, filters });
export const setListHomestays = (data) => ({ type: Types.HOMESTAY_LIST_SUCCESS, homestays: data.homestays, pageIndex: data.pageIndex, pageSize: data.pageSize, totalCount: data.totalCount });

export const getHomestayDetail = (id) => ({ type: Types.HOMESTAY_DETAIL_ACTION, id });
export const setHomestayDetail = (homestay) => ({ type: Types.HOMESTAY_DETAIL_SUCCESS, homestay });
export const updateHomestayDetail = (homestay) => ({ type: Types.HOMESTAY_DETAIL_UPDATE_ACTION, homestay });
export const createHomestayDetail = (homestay) => ({ type: Types.HOMESTAY_DETAIL_CREATE_ACTION, homestay });

export const createHomestayTranslate = (homestay) => ({type: Types.HOMESTAY_CREATE_TRANSLATE_ACTION, homestay});
export const updateHomestayTranslate = (homestay) => ({type: Types.HOMESTAY_UPDATE_TRANSLATE_ACTION, homestay});
export const deleteHomestayTranslate = (homestay, refreshParams) => ({type: Types.HOMESTAY_DELETE_TRANSLATE_ACTION, homestay, refreshParams});

export const getTagGroupDetailSku = (id) => ({ type: Types.HOMESTAY_TAG_GROUP_DETAIL_SKU_ACTION, id });
export const setTagGroupDetailSku = (data) => ({ type: Types.HOMESTAY_TAG_GROUP_DETAIL_SKU_SUCCESS, tagsGroupDetail: data });

export const updateTagGroupDetailSkuActive = (data, id) => ({ type: Types.HOMESTAY_TAG_GROUP_DETAIL_SKU_ACTIVE_ACTION, data, id });

export const getAllHomestayActive = (params) => ({type: Types.HOMESTAY_ALL_ACTIVE_ACTION, params});
export const setAllHomestayActive = (data) => ({ type: Types.HOMESTAY_ALL_ACTIVE_SUCCESS, homestayActive: data })

export const clearCache = (value) => ({ type: Types.CLEAR_CACHE_ACTION, value });

export const getListRateCompare = (filters) => ({ type: Types.RATE_LIST_COMPARE_ACTION, filters });
export const setListRateCompare = (data) => ({ type: Types.RATE_LIST_COMPARE_SUCCESS, rateCompareList: data });
export const createRateCompare = (data) => ({ type: Types.RATE_LIST_COMPARE_CREATE_ACTION, data });
export const updateRateCompare = (data) => ({ type: Types.RATE_LIST_COMPARE_UPDATE_ACTION, data });
export const deleteRateCompare = (data) => ({ type: Types.RATE_LIST_COMPARE_DELETE_ACTION, data });
